{
  function getStickyHeaderHeight() {
    const header = document.querySelector('.main-header')
    let offset = 0
    if (header && (window.getComputedStyle(header).position === 'sticky' || window.getComputedStyle(header).position === 'fixed')) {
      offset = header.offsetHeight
    }
    return offset
  }

  function hasStickyHeader() {
    const header = document.querySelector('.main-header')
    return header && (window.getComputedStyle(header).position === 'sticky' || window.getComputedStyle(header).position === 'fixed')
  }

  function setScrollOffset() {
    if(hasStickyHeader()){
      const offset = getStickyHeaderHeight()
      document.querySelector('html').style.scrollPaddingTop = `${offset}px`
    }
  }

  // we run this twice because we need to account for lazy loaded images and such
  function adjustScrollForAnchor(doItAgain) {
    if (window.location.hash && hasStickyHeader()) {
      // Defer adjusting the scroll until after the browser scrolls to the anchor
      requestAnimationFrame(() => {
        const offset = getStickyHeaderHeight()
        const target = document.querySelector(window.location.hash)
        if (target) {
          const targetPosition = target.getBoundingClientRect().top + window.scrollY
          window.scrollTo({ top: targetPosition - offset })
        }
        if(doItAgain){
          setTimeout(() => adjustScrollForAnchor(false), 500)
        }
      })
    }
  }

  function setCompressClass(){
    const header = document.querySelector('.main-header')
    if(header){
      if(window.scrollY > window.innerHeight * 0.5){
        header.classList.add('compress')
      } else {
        header.classList.remove('compress')
      }
    }
  }

  window.addEventListener('load', () => {
    setScrollOffset()
    adjustScrollForAnchor(true)
  })

  window.addEventListener('resize', setScrollOffset)

  window.addEventListener('scroll', setCompressClass)
}
